/**
 * 토큰 검증 유틸리티 함수들
 */

import type { ResolvedStorageKeys } from '../storage-keys';
import { resolveStorageKeys } from '../storage-keys';

/**
 * ID 토큰 유효성 검사 (기본적인 JWT 형식 확인)
 */
export const isValidIdToken = (token: string | null): boolean => {
  if (!token) return false;
  
  try {
    // JWT는 3개 부분으로 구성됨 (header.payload.signature)
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.warn('[AuthUtils] ID 토큰 형식 오류: JWT 구조 불일치');
      return false;
    }
    
    // 기본적인 base64 디코딩 테스트
    const payload = JSON.parse(atob(parts[1]));
    
    // exp (만료시간) 확인
    if (payload.exp && Date.now() >= payload.exp * 1000) {
      console.warn('[AuthUtils] ID 토큰 만료:', new Date(payload.exp * 1000));
      return false;
    }
    
    return true;
  } catch (error) {
    console.warn('[AuthUtils] ID 토큰 검증 실패:', error);
    return false;
  }
};

/**
 * localStorage에서 유효한 ID 토큰 조회
 */
export const getValidIdToken = (storageKeys?: Partial<ResolvedStorageKeys>): string | null => {
  const resolvedStorageKeys = resolveStorageKeys(storageKeys);
  const rawIdToken = localStorage.getItem(resolvedStorageKeys.idTokenKey);
  return isValidIdToken(rawIdToken) ? rawIdToken : null;
};
